"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceLocation = exports.handleRedirect = exports.goToRedirectPage = exports.goToLoginPageIfInvalidSession = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _reactRouterRedux = require("react-router-redux");
var _redirectDomains = require("../utils/redirectDomains");
var _yieldToMain = _interopRequireDefault(require("../utils/yieldToMain"));
var goToRedirectPage = function goToRedirectPage(_ref) {
  var redirectUrl = _ref.redirectUrl,
    dispatch = _ref.dispatch;
  if (redirectUrl) {
    var decoded = decodeURIComponent(redirectUrl);
    if (redirectUrl.indexOf("http") >= 0) {
      replaceLocation(decoded);
    } else {
      dispatch((0, _reactRouterRedux.replace)(decoded));
    }
  }
};
exports.goToRedirectPage = goToRedirectPage;
var replaceLocation = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(decodedUrl) {
    var includesValidRedirect;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            includesValidRedirect = _redirectDomains.REDIRECT_DOMAINS.some(function (domain) {
              return decodedUrl.includes(domain);
            });
            _context.next = 3;
            return (0, _yieldToMain.default)();
          case 3:
            window.location.replace(includesValidRedirect ? decodedUrl : "/");
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function replaceLocation(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.replaceLocation = replaceLocation;
var handleRedirect = function handleRedirect(_ref3) {
  var isLoggedIn = _ref3.isLoggedIn,
    saveRedirectUrl = _ref3.saveRedirectUrl,
    location = _ref3.location,
    dispatch = _ref3.dispatch;
  var redirectUrl = location.query.redirect !== undefined ? location.query.redirect : "/";
  if (isLoggedIn) {
    goToRedirectPage({
      redirectUrl: redirectUrl,
      dispatch: dispatch
    });
  } else {
    saveRedirectUrl(redirectUrl);
  }
};
exports.handleRedirect = handleRedirect;
var goToLoginPageIfInvalidSession = function goToLoginPageIfInvalidSession(sessionId, goToLoginPage) {
  if (!sessionId) {
    goToLoginPage();
  }
};
exports.goToLoginPageIfInvalidSession = goToLoginPageIfInvalidSession;